import numeral from 'numeral';
import { map } from 'lodash';
import moment from 'moment';

export const formatTrendingActors = ({ data = [], fields = {} } = {}) =>
  map(data, actor => ({
    id: actor[fields.actorId],
    image: actor[fields.actorImageUrl],
    name: actor[fields.actorName],
    score: numeral(actor[fields.actorVoteCount]).format('0,0')
  }));

export const formatTrendingShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    showTitle: {
      type: 'link',
      label: show[fields.showName],
      url: `/show/${show[fields.showId]}`
    },
    network: {
      type: 'link',
      label: show[fields.showNetworkName],
      url: `/network/${show[fields.showNetworkId]}`
    },
    percentIncrease: {
      type: 'string',
      value: `${numeral(show[fields.showPercentIncrease] * 100).format('0')}%`
    }
  }));

export const formatTopShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    showTitle: {
      type: 'link',
      label: show[fields.showName],
      url: `/show/${show[fields.contentId]}`
    },
    network: {
      type: 'string',
      value: show[fields.showNetworkName]
    },
    viewShare: {
      type: 'string',
      value: `${numeral(show[fields.viewShare]).format('0.00')}%`
    },
    viewerShare: {
      type: 'string',
      value: `${numeral(show[fields.viewerShare]).format('0.00')}%`
    }
  }));

export const formatTopShowsBinged = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    showTitle: {
      type: 'link',
      label: show[fields.showName],
      url: `/show/${show[fields.showId]}`
    },
    network: {
      type: 'string',
      value: show[fields.showNetworkName]
    },
    bingeRate: {
      type: 'string',
      value: `${numeral(show[fields.bingeRate] * 100).format('0.00')}%`
    },
    bingeShare: {
      type: 'string',
      value: `${numeral(show[fields.bingeShare] * 100).format('0.00')}%`
    }
  }));

export const formatAnticipatedShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    showTitle: {
      type: 'link',
      label: show[fields.showName],
      url: `/show/${show[fields.showId]}`
    },
    network: {
      type: 'link',
      label: show[fields.network],
      url: `/network/${show[fields.networkId]}`
    },
    releaseDate: {
      type: 'string',
      value: moment(show[fields.releaseDate]).format('MM-DD-YYYY')
    }
  }));

export const formatAnticipatedMovies = ({ data = [], fields = {} }) =>
  map(data, movie => ({
    title: {
      type: 'link',
      label: movie[fields.movieName],
      url: `/movie/${movie[fields.movieId]}`
    },
    studio: {
      type: 'string',
      value: movie[fields.studio]
    },
    releaseDate: {
      type: 'string',
      value: moment(movie[fields.releaseDate]).format('MM-DD-YYYY')
    }
  }));

export const formatTopMovies = ({ data = [], fields = {} } = {}) =>
  map(data, movie => ({
    title: {
      type: 'link',
      label: movie[fields.movieName],
      url: `/movie/${movie[fields.movieId]}`
    },
    studio: {
      type: 'string',
      value: movie[fields.studioName]
    },
    viewShare: {
      type: 'string',
      value: `${numeral(movie[fields.viewShare] * 100).format('0.00')}%`
    },
    viewers: {
      type: 'string',
      value: `${numeral(movie[fields.viewers]).format('0,0')}`
    }
  }));

export const formatTrendingMovies = ({ data = [], fields = {} } = {}) =>
  map(data, movie => ({
    title: {
      type: 'link',
      label: movie[fields.movieName],
      url: `/movie/${movie[fields.movieId]}`
    },
    studio: {
      type: 'string',
      value: movie[fields.studioName]
    },
    percentIncrease: {
      type: 'string',
      value: `${numeral(movie[fields.percentIncrease] * 100).format('0')}%`
    }
  }));

export const formatMovieTrendingActors = ({ data = [], fields = {} } = {}) =>
  map(data, actor => ({
    id: actor[fields.actorId],
    image: actor[fields.actorImageUrl],
    name: actor[fields.actorName],
    score: numeral(actor[fields.actorVoteCount]).format('0,0')
  }));

export const formatHomepageShowsHottestMoments = ({
  data = [],
  fields = {}
} = {}) =>
  map(data, moment => ({
    id: moment[fields.id],
    image: moment[fields.imageUrl],
    title: moment[fields.title],
    subtitle: moment[fields.subtitle],
    memeCount: moment[fields.memeCount],
    totalCount: moment[fields.activityCount],
    itemType: 'show'
  }));
